/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

/* Graphics kit add-ons: shows Mini Plates + Fork Stickers as a step in the
   graphics kit builder (after Custom logo), adds them to the total, and adds
   them to the cart together with the kit. */
(function () {
  var ADDON_HANDLES = ['mini-plates-3', 'fork-sticker'];
  var nativeFetch = window.fetch.bind(window);
  var addons = [];
  var lastTotal = '';
  var baseTotal = null;

  function cents(t) {
    var m = String(t || '').match(/\d[\d,]*(\.\d+)?/);
    return m ? Math.round(parseFloat(m[0].replace(/,/g, '')) * 100) : 0;
  }
  function fmt(c, sample) {
    var n = (c / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (sample && /\d/.test(sample)) return sample.replace(/\d[\d,]*(\.\d+)?/, n);
    return '$' + n;
  }
  function esc(t) {
    return String(t).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function variantOf(a) {
    if (a.product.variants.length === 1) return a.product.variants[0];
    var want = [];
    a.el.querySelectorAll('[data-zr-opt]').forEach(function (g) {
      var b = g.querySelector('button.active');
      want[+g.getAttribute('data-zr-opt')] = b ? b.getAttribute('data-value') : null;
    });
    return a.product.variants.find(function (v) {
      return v.options.every(function (o, i) { return want[i] == null || o === want[i]; });
    }) || null;
  }
  function addonSum() {
    var t = 0;
    addons.forEach(function (a) { if (a.on) { var v = variantOf(a); if (v) t += v.price; } });
    return t;
  }
  function picked() {
    var kit = document.querySelector('#zc-form h1');
    var items = [];
    addons.forEach(function (a) {
      if (!a.on) return;
      var v = variantOf(a);
      if (!v) return;
      var props = { 'For kit': kit ? kit.textContent.trim() : '' };
      var sp = a.el.querySelector('.zr-sponsor');
      if (sp) {
        props['Suspension sponsor'] = sp.value.trim();
        var lg = document.getElementById('zc-logo');
        props['Sponsor logo'] = lg && lg.files && lg.files.length ? 'Uploaded with kit (' + lg.files[0].name + ')' : 'Not uploaded';
      }
      items.push({ id: v.id, quantity: 1, properties: props });
    });
    return items;
  }

  function renderTotal() {
    var el = document.getElementById('zc-total');
    if (!el || !baseTotal) return;
    lastTotal = fmt(baseTotal.c + addonSum(), baseTotal.t);
    el.textContent = lastTotal;
  }
  function hookTotal() {
    var el = document.getElementById('zc-total');
    if (!el || el.__zrHooked) return;
    el.__zrHooked = true;
    baseTotal = { c: cents(el.textContent), t: el.textContent };
    new MutationObserver(function () {
      if (el.textContent === lastTotal) return;
      baseTotal = { c: cents(el.textContent), t: el.textContent };
      renderTotal();
    }).observe(el, { childList: true, characterData: true, subtree: true });
  }

  function renderSummary() {
    var box = document.getElementById('zc-summary');
    if (!box) return;
    box.querySelectorAll('[data-zr-row]').forEach(function (r) { r.remove(); });
    addons.forEach(function (a) {
      if (!a.on) return;
      var v = variantOf(a);
      if (!v) return;
      var label = (v.title && v.title !== 'Default Title' ? v.title + ' · ' : '') + fmt(v.price, baseTotal && baseTotal.t);
      box.insertAdjacentHTML('beforeend', '<div class="zc-row" data-zr-row><span class="k">' + esc(a.product.title) + '</span><span class="v">' + esc(label) + '</span></div>');
    });
  }
  function hookSummary() {
    var box = document.getElementById('zc-summary');
    if (!box || box.__zrHooked) return;
    box.__zrHooked = true;
    new MutationObserver(function () {
      if (!box.querySelector('[data-zr-row]') && addons.some(function (a) { return a.on; })) renderSummary();
    }).observe(box, { childList: true });
  }

  function refresh() {
    addons.forEach(function (a) {
      var v = variantOf(a);
      var p = a.el.querySelector('.zr-addon-price');
      if (p && v) p.textContent = fmt(v.price, baseTotal && baseTotal.t);
    });
    renderTotal();
    renderSummary();
  }

  function build(products, logoSec) {
    var steps = document.querySelectorAll('#zc .zc-section h2 .step');
    var n = 0;
    steps.forEach(function (s) { var x = parseInt(s.textContent, 10); if (x > n) n = x; });
    var sec = document.createElement('div');
    sec.className = 'zc-section';
    sec.id = 'zc-addons';
    var html = '<h2><span class="step">' + (n + 1) + '</span>Add to your kit<span class="opt">Optional</span></h2>' +
      '<div class="sub">Extras made to match your kit.</div>';
    products.forEach(function (p, i) {
      var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
      html += '<div class="zr-addon" data-zr-i="' + i + '"><div class="zr-addon-top">' +
        (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" width="56" height="56" loading="lazy">' : '') +
        '<div class="zr-addon-info"><div class="zr-addon-title">' + esc(p.title) + '</div><div class="zr-addon-price"></div></div>' +
        '<button type="button" class="zr-addon-btn" aria-pressed="false">Add</button></div>';
      if (p.handle === 'fork-sticker') {
        html += '<div class="zr-addon-extra" hidden><div class="zc-field"><label for="zr-sponsor">Suspension sponsor</label>' +
          '<input type="text" id="zr-sponsor" class="zr-sponsor" placeholder="e.g. Fox, WP, Showa, Enzo" autocomplete="off"></div>' +
          '<div class="zr-addon-note">Upload your suspension sponsor logo in step ' + n + ' (Custom logo) above so we can put it on your fork stickers.</div></div>';
      }
      if (p.variants.length > 1) {
        p.options.forEach(function (o, oi) {
          html += '<div class="zr-addon-optlbl">' + esc(o.name) + '</div><div class="zc-chips" data-zr-opt="' + oi + '">';
          o.values.forEach(function (val, vi) {
            html += '<button type="button"' + (vi === 0 ? ' class="active"' : '') + ' data-value="' + esc(val) + '">' + esc(val) + '</button>';
          });
          html += '</div>';
        });
      }
      html += '</div>';
    });
    sec.innerHTML = html;
    logoSec.insertAdjacentElement('afterend', sec);

    addons = products.map(function (p, i) {
      return { product: p, el: sec.querySelector('[data-zr-i="' + i + '"]'), on: false };
    });
    addons.forEach(function (a) {
      var btn = a.el.querySelector('.zr-addon-btn');
      btn.addEventListener('click', function () {
        a.on = !a.on;
        btn.classList.toggle('on', a.on);
        btn.setAttribute('aria-pressed', a.on ? 'true' : 'false');
        btn.textContent = a.on ? 'Added' : 'Add';
        var ex = a.el.querySelector('.zr-addon-extra');
        if (ex) { ex.hidden = !a.on; if (a.on) { var f = ex.querySelector('input'); if (f) setTimeout(function () { f.focus(); }, 50); } }
        sec.classList.remove('zc-err');
        refresh();
      });
      a.el.querySelectorAll('[data-zr-opt] button').forEach(function (b) {
        b.addEventListener('click', function () {
          b.parentElement.querySelectorAll('button').forEach(function (x) { x.classList.toggle('active', x === b); });
          refresh();
        });
      });
    });
    hookTotal();
    hookSummary();
    refresh();
  }

  function init() {
    var root = document.getElementById('zc');
    if (!root || root.getAttribute('data-kind') !== 'graphics' || document.getElementById('zc-addons')) return;
    var drop = document.getElementById('zc-drop');
    var logoSec = drop && drop.closest('.zc-section');
    if (!logoSec) return;
    addons = [];
    baseTotal = null;
    Promise.all(ADDON_HANDLES.map(function (h) {
      return nativeFetch('/products/' + h + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (list) {
      var products = list.filter(function (p) { return p && p.available; });
      if (products.length && !document.getElementById('zc-addons')) build(products, logoSec);
    });
  }

  window.fetch = function (input, opts) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var res = nativeFetch(input, opts);
    if (url.indexOf('/cart/add') > -1 && opts && opts.body instanceof FormData && document.getElementById('zc-addons')) {
      var items = picked();
      if (items.length) {
        return res.then(function (r) {
          if (!r.ok) return r;
          return nativeFetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: items })
          }).then(function () { return r; }, function () { return r; });
        });
      }
    }
    return res;
  };

  var css = document.createElement('style');
  css.textContent =
    '.zr-addon{border:1px solid rgba(127,127,127,.25);border-radius:12px;padding:12px;margin-top:12px}' +
    '.zr-addon-top{display:flex;align-items:center;gap:12px}' +
    '.zr-addon-top img{width:56px;height:56px;object-fit:cover;border-radius:8px;flex-shrink:0}' +
    '.zr-addon-info{flex:1;min-width:0}' +
    '.zr-addon-title{font-weight:600;line-height:1.3}' +
    '.zr-addon-price{opacity:.7;font-size:.9em;margin-top:2px}' +
    '.zr-addon-btn{flex-shrink:0;padding:8px 16px;border-radius:999px;border:1.5px solid currentColor;background:transparent;color:inherit;font-weight:600;cursor:pointer}' +
    '.zr-addon-btn.on{background:#e63946;border-color:#e63946;color:#fff}' +
    '.zr-addon-optlbl{font-size:.85em;opacity:.7;margin:12px 0 6px}' +
    '.zr-addon-extra{margin-top:12px}.zr-addon-extra .zc-field input{width:100%}' +
    '.zr-addon-note{font-size:.85em;opacity:.75;margin-top:8px;line-height:1.4}' +
    '#zc-addons .zc-chips{display:flex!important;flex-wrap:wrap;gap:6px;grid-template-columns:none!important}' +
    '#zc-addons .zc-chips button{flex:1 1 0;min-width:max-content;width:auto!important;white-space:nowrap;padding-left:12px;padding-right:12px}';
  document.head.appendChild(css);

  /* Drop "chrome/metallic" from the builder notice, since chrome options are offered */
  function fixNotice() {
    document.querySelectorAll('.zc-notice div').forEach(function (d) {
      if (d.textContent.indexOf('chrome/metallic, ') > -1) d.textContent = d.textContent.replace('chrome/metallic, ', '');
    });
  }

  /* Graphics Lab / brand graphics pages: separate Accessories row above Upgrades */
  function accessories() {
    var zl = document.getElementById('zl');
    if (!zl || zl.getAttribute('data-mode') !== 'gfx' || document.getElementById('zr-acc')) return;
    var upg = zl.querySelector('.zl-upg');
    var anchor = upg && upg.previousElementSibling;
    if (!anchor) return;
    Promise.all(ADDON_HANDLES.map(function (h) {
      return nativeFetch('/products/' + h + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (list) {
      var products = list.filter(function (p) { return p && p.available; });
      if (!products.length || document.getElementById('zr-acc')) return;
      var cards = products.map(function (p) {
        var im = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=700' : '';
        var price = fmt(p.price_min).replace(/\.00$/, '');
        return '<a class="zl-card" href="/products/' + p.handle + '"><div class="zl-img"><span class="zl-badge">Accessory</span>' +
          (im ? '<img src="' + esc(im) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') +
          '</div><div class="zl-body"><div class="zl-name">' + esc(p.title) + '</div><div class="zl-meta">Made to match your kit</div>' +
          '<div class="zl-row" style="margin-top:12px"><div class="zl-price"><small>FROM</small>' + price + '</div><div class="zl-build">Shop</div></div></div></a>';
      }).join('');
      var head = document.createElement('div');
      head.className = 'zl-sec';
      head.style.paddingTop = '0';
      head.id = 'zr-acc-head';
      head.style.scrollMarginTop = '90px';
      head.innerHTML = '<h2 class="zl-h2">Accessories</h2>';
      var grid = document.createElement('div');
      grid.className = 'zl-grid';
      grid.id = 'zr-acc';
      grid.style.paddingBottom = '32px';
      grid.innerHTML = cards;
      anchor.parentNode.insertBefore(head, anchor);
      anchor.parentNode.insertBefore(grid, anchor);
      if (location.hash === '#accessories') setTimeout(goAccessories, 300);
    });
  }

  /* Block add to cart if fork stickers are added without a sponsor name */
  document.addEventListener('submit', function (e) {
    if (!e.target || e.target.id !== 'zc-form') return;
    var sp = document.querySelector('#zc-addons .zr-sponsor');
    var ex = sp && sp.closest('.zr-addon-extra');
    if (!sp || !ex || ex.hidden || sp.value.trim()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var sec = document.getElementById('zc-addons');
    sec.classList.add('zc-err');
    var tt = document.getElementById('zc-toast-t'), tb = document.getElementById('zc-toast-b'), to = document.getElementById('zc-toast');
    if (tt && tb && to) { tt.textContent = 'Almost there'; tb.textContent = 'Please enter your suspension sponsor for the fork stickers.'; to.classList.add('show'); setTimeout(function () { to.classList.remove('show'); }, 6000); }
    sec.scrollIntoView({ behavior: 'smooth', block: 'center' });
    setTimeout(function () { sp.focus({ preventScroll: true }); }, 350);
  }, true);

  /* Accessories tile in the Shop by bike picker */
  function goAccessories() {
    var h = document.getElementById('zr-acc-head') || (document.querySelector('#zl .zl-upg') || {}).previousElementSibling;
    if (!h) return;
    var top = h.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop) - 100;
    var before = window.pageYOffset;
    try { window.scrollTo({ top: top, behavior: 'smooth' }); } catch (err) { window.scrollTo(0, top); }
    setTimeout(function () {
      if (Math.abs(window.pageYOffset - before) < 5) h.scrollIntoView(true);
    }, 600);
  }
  function bikeTile() {
    var bl = document.getElementById('zl-bike-list');
    if (!bl || !bl.firstElementChild || document.getElementById('zr-acc-tile')) return;
    var t = document.createElement('button');
    t.type = 'button';
    t.id = 'zr-acc-tile';
    t.className = 'zl-bike';
    t.innerHTML = 'Accessories<small>' + ADDON_HANDLES.length + ' items</small>';
    t.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      goAccessories();
    });
    bl.firstElementChild.insertAdjacentElement('afterend', t);
  }
  /* Menu link "Accessories" (/collections/graphics-lab#accessories) */
  document.addEventListener('click', function (e) {
    var l = e.target.closest && e.target.closest('a[href$="#accessories"]');
    if (!l || !document.getElementById('zl') || document.getElementById('zl').getAttribute('data-mode') !== 'gfx') return;
    e.preventDefault();
    var hd = document.getElementById('zr-header');
    if (hd) { hd.classList.remove('zr-open'); var bg = hd.querySelector('.zr-burger'); if (bg) bg.setAttribute('aria-expanded', 'false'); }
    setTimeout(goAccessories, 50);
  }, true);
  var bl0 = document.getElementById('zl-bike-list');
  if (bl0) { bikeTile(); new MutationObserver(bikeTile).observe(bl0, { childList: true }); }

  fixNotice();
  accessories();
  init();
  var swap = document.getElementById('zc-swap');
  if (swap) new MutationObserver(function () { setTimeout(function () { fixNotice(); init(); }, 0); }).observe(swap, { childList: true });
})();
